export enum AlertNotifications {
  sound = 'sound',
  email = 'email',
  push = 'push',
  browserPush = 'browserPush',
}
